//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReportContentItem from './ReportContentItem.vue'
import { documentContentStoreMixin } from './documentContentStoreMixin.js'

export default {
  name: 'ReportContent',
  components: {
    ReportContentItem
  },
  mixins: [documentContentStoreMixin],
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    contentsTree () {
      return this.contentGetter('getContentsTree')
    },
    scrollTop () {
      return this.contentGetter('getScrollTop')
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.restoreScrollPosition()
    })
  },
  beforeDestroy: function () {
    this.persistScrollPosition()
  },
  methods: {
    setAllExpanded (expand) {
      return this.contentDispatch('setAllExpanded', expand)
    },
    setScrollTop (scrollTop) {
      return this.contentDispatch('setScrollTop', scrollTop)
    },
    getScrollAreaVerticalPosition () {
      const scrollArea = this.$refs.scrollArea
      if (!scrollArea) {
        return 0
      }
      if (typeof scrollArea.getScrollPosition === 'function') {
        const position = scrollArea.getScrollPosition()
        if (typeof position === 'number') {
          return position
        }
        if (position && typeof position.top === 'number') {
          return position.top
        }
      }
      if (typeof scrollArea.getScrollTarget === 'function') {
        const target = scrollArea.getScrollTarget()
        if (target && typeof target.scrollTop === 'number') {
          return target.scrollTop
        }
      }
      return 0
    },
    persistScrollPosition () {
      this.setScrollTop(this.getScrollAreaVerticalPosition())
    },
    restoreScrollPosition () {
      const scrollArea = this.$refs.scrollArea
      if (!scrollArea || typeof scrollArea.setScrollPosition !== 'function') {
        return
      }
      scrollArea.setScrollPosition('vertical', this.scrollTop || 0)
    },
    onScroll () {
      this.persistScrollPosition()
    }
  }
}
